import React, { useRef } from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

import AudioPlayer from "~/components/Media/Audio";
import VideoPlayer from "~/components/Media/Video";
import { base64url, EncryptJWT, UnsecuredJWT } from "jose";

const Media = styled("img")(() => ({
  width: "100%",
  maxWidth: "100%",
  height: "auto"
}));

const Description = styled("p")(() => ({
  whiteSpace: "pre-wrap"
}));

function buildEditorLink(baseurl, jwt) {
  // baseurl + ""?d=" + JWT
  return `${baseurl}?d=${jwt}`;
}

function MaterialRenderer({ renderType, mimeType, sourcePath, linkText, shortDescription, ...rest }) {
  const audioRef = useRef(null);
  const videoRef = useRef(null);

  let content;

  switch (renderType) {
    case "directplayer":
    case "audio":
      content = <AudioPlayer ref={audioRef} sourcePath={sourcePath} mimeType={mimeType} />;
      break;

    case "video":
      content = <VideoPlayer ref={videoRef} sourcePath={sourcePath} mimeType={mimeType} />;
      break;

    case "image":
      content = <Media className="lazyload" title={linkText} alt={linkText} data-src={sourcePath} />;
      break;

    case "game":
    case "file":
    case "link":
    case "worksheet":
      content = (
        <a target="_blank" href={sourcePath} rel="noopener noreferrer">
          {linkText ? linkText : sourcePath}
        </a>
      );
      break;
    case "arbeitsblatteditor": {
      const baseUrl = window.getClientConfiguration("", ["arbeitsblatteditor", "baseurl"]);
      const payload = { url: sourcePath.replace("buch.local", "devbuch.mildenberger-digital.de") };
      const jwt = new UnsecuredJWT(payload).setIssuedAt().encode();

      const link = buildEditorLink(baseUrl, jwt);
      content = (
        <a target="_blank" href={link} rel="noopener noreferrer">
          {linkText ? linkText : link}
        </a>
      );

      break;
    }

    default:
      console.error("Unknown renderType: [%s]", renderType);
      content = "Materialtyp wird nicht unterstützt";
  }

  return (
    <>
      {content && content}
      {shortDescription && <Description>{shortDescription}</Description>}
    </>
  );
}

MaterialRenderer.propTypes = {
  renderType: PropTypes.string,
  mimeType: PropTypes.string,
  sourcePath: PropTypes.string,
  linkText: PropTypes.string,
  shortDescription: PropTypes.string
};

MaterialRenderer.defaultProps = {
  renderType: "",
  mimeType: "",
  sourcePath: "",
  linkText: "",
  shortDescription: ""
};

export default MaterialRenderer;
